// removed by extract-text-webpack-plugin
module.exports = {"search-wrapper":"style__search-wrapper___3TzAc","search-label":"style__search-label___27Rp5","search-button-wrapper":"style__search-button-wrapper___IYj_7","search-box-wrapper":"style__search-box-wrapper___MtH1v","search-button":"style__search-button___aygvQ","search-box":"style__search-box___3KMVt"};


//////////////////
// WEBPACK FOOTER
// ./components/EventSearch/style.scss
// module id = 1190
// module chunks = 0